import { readingGuideSteps } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function ReadingGuide() {
  return (
    <section id="guide" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <SectionHeading
          kicker="Reading Guide"
          title="阅读指南：四步找到你想看的部分"
          desc="第一次打开这一页不知道该从哪里看？按下面四个步骤走一遍，基本就能定位到自己最关心的内容形态与章节位置。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {readingGuideSteps.map((step) => (
            <article
              key={step.step}
              className="relative p-5 rounded-lg bg-background-100 border border-background-200 flex flex-col gap-3"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 rounded-md bg-accent-100 text-accent-900 flex items-center justify-center">
                  <i className={`${step.icon} text-xl`} />
                </span>
                <span className="font-heading text-2xl font-semibold text-background-300">{step.step}</span>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{step.title}</h3>
              <p className="text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}